import axios from '../utils/axios'
const API_URL = process.env.REACT_APP_API_URL + "/v1/client/";


const getAllPatients = (clinicId,pageNo=0, pageSize=10, query)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/patients?pageNo="+pageNo+"&pageSize="+pageSize+"&"+query);
}

const getPatientById = (clinicId,patientId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/patients/"+patientId)
}
const updatePatient = (clinicId,patientId,data)=>{
    return axios.put(API_URL+"clinics/"+clinicId+"/patients/"+patientId,data)
}
const getCommunicationPreferences = (clinicId,patientId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/comm-prefs")
}

const updateCommunicationPreferences = (clinicId,patientId,data)=>{
    return axios.put(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/comm-prefs",data)
}

const getPatientInvalidDetails = (clinicId,patientId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/invalid-details")
}

const updatePatientInvalidDetails = (clinicId,patientId,data)=>{
    return axios.put(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/invalid-details",data)
}
 
const getPatientAppointments = (clinicId,patientId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/appointments")
}

const getPatientCommunicationPreferences = (clinicId,patientId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/comm-prefs")
}
const updatePatientCommunicationPreferences = (clinicId,patientId,data)=>{
    return axios.put(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/comm-prefs",data)
}
const getPatientInvalidData = (clinicId,patientId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/invalid-details")
}

const deletePatientInvalidData = (clinicId,patientId,data)=>{
    return axios.delete(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/invalid-details", { data });
}

const getPatientActivities = (clinicId,patientId,pageNumber=0)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/activity?pageNumber="+pageNumber)
}

const patientService = {
    getAllPatients,
    getPatientById,
    updatePatient,
    getCommunicationPreferences,
    updateCommunicationPreferences,
    getPatientInvalidDetails,
    updatePatientInvalidDetails,
    getPatientAppointments,
    getPatientCommunicationPreferences,
    updatePatientCommunicationPreferences,
    getPatientInvalidData,
    deletePatientInvalidData,
    getPatientActivities
}

export default patientService